import React, { useEffect, useState, } from 'react'
import { useParams } from 'react-router-dom'
import ProgressCircle from '../../../components/ProgressCircle'
import firebase from 'firebase';
import firebaseGetImageUrl from '../../../helpers/firebaseGetImageUrl';
import Product from './../../../components/Product';
import styles from './style.module.css';

const PLACEHOLDER_USER = 'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse1.mm.bing.net%2Fth%3Fid%3DOIP.6yuCxX3agcmqdUaie4OZwQAAAA%26pid%3DApi&f=1';

export default function UserProfile() {
  // eslint-disable-next-line no-unused-vars
  const { uid } = useParams();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({})
  const [avatar, setAvatar] = useState(PLACEHOLDER_USER)
  const [products, setProducts] = useState([])
  const [loadingProducts, setLoadingProducts] = useState(false)

  async function GetFullDeliveryInfo() {
    if (loading) return;
    setLoading(true)
    const getUser = await firebase.functions().httpsCallable('getUser')({
      uid: uid,
    })
    if (getUser.data.data) {
      setUser(getUser.data.data)
      if (getUser.data?.data?.avatar) {
        const image = await firebaseGetImageUrl(getUser.data?.data?.avatar, 512, 2);
        setAvatar(image || PLACEHOLDER_USER);
      }
    }
    setLoading(false)
  }

  async function loadProducts() {
    setLoadingProducts(true)
    const result = await firebase.functions().httpsCallable('getAdminUsersProducts')({
      uid: uid,
    })
    if (result.data.result) {
      setProducts(result.data.data)
    } else {
      setProducts([])
    }
    setLoadingProducts(false)
  }

  useEffect(() => {
    GetFullDeliveryInfo();
    loadProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <div style={{ width: 'max-content', margin: 'auto', marginTop: '42vh' }}>
      <ProgressCircle />
    </div>;
  }

  return (
    <div className="container-sm p-2">
      <div className="card">
        <div style={{
          display: 'flex',
          flexDirection: 'row'
        }}>
          <img

            src={avatar}
            style={{
              width: 256,
              height: 256
            }}
            alt="avatar" />
          <div style={{ paddingLeft: 20 }}>
            <p className="m-0"><b>username:</b> {user?.username}</p>
            <p className="m-0"><b>full name:</b> {user?.firstName} {user?.lastName}</p>
            <p className="m-0"><b>mob.number:</b> {user?.mobileNumber}</p>
            <p className="m-0"><b>email:</b> {user?.email}</p>
            <p className="m-0"><b>address:</b> {user?.address}</p>
            <p className="m-0"><b>bankNumber:</b> {user?.bankDetails}</p>
          </div>
        </div>
      </div>
      <div className="card mt-3 p-3">
        <div className={styles.productsContainer}>
          {loadingProducts ?
            <ProgressCircle />
            :
            products?.map((data, i) => {
              return <Product key={i} data={data} />
            })
          }
        </div>
      </div>
    </div>
  )
}
